// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonTertiaryToggleGroupOn = 2;
var ButtonTertiaryToggleGroupOff = 2;
var BorderWidthSemanticsAll = {
  ButtonTertiaryToggleGroupOff: ButtonTertiaryToggleGroupOff,
  ButtonTertiaryToggleGroupOn: ButtonTertiaryToggleGroupOn
};

export { BorderWidthSemanticsAll, ButtonTertiaryToggleGroupOff, ButtonTertiaryToggleGroupOn, BorderWidthSemanticsAll as default };
